export const URL_KEYS = {
  SEARCH: 'search',
  PAGE: 'page',
  SCHOOL_ID: 'schoolId',
  LANG: 'lang',
  TIME_TYPE: 'timeType'
}
